module.exports = __webpack_public_path__ + "static/media/security.a48f9bea.jpg";